import Vue from 'vue'
import mainVue from './main.vue'

const defaults = {}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox

const defaultCallback = value => {
  if (currentBox) {
    let callback = currentBox.callback
    if (typeof callback === 'function') {
      callback(value)
    }
  }
}

const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })

  instance.callback = defaultCallback
}

const showBox = () => {
  initInstance()

  instance.content = ''

  if (currentBox) {
    let options = currentBox.options
    for (let prop in options) {
      if (options.hasOwnProperty(prop)) {
        instance[prop] = options[prop]
      }
    }

    if (options.callback === undefined) {
      instance.callback = defaultCallback
    }

    let oldCb = instance.callback
    instance.callback = (value, instance) => {
      oldCb(value, instance)
    }

    if (options.onClick) {
      instance.$on('click', options.onClick)
    }

    options.container.appendChild(instance.$el)

    Vue.nextTick(() => {
      instance.visible = true
      !instance.mount && (instance.mount = true)
    })
  }
}

const QuestionQuillEditor = function (options, callback) {
  if (Vue.prototype.$isServer) return
  if (options.callback && !callback) {
    callback = options.callback
  }
  if (!options.container) {
    options.container = document.body
  }

  currentBox = {
    options: _.merge({}, defaults, QuestionQuillEditor.defaults, options),
    callback: callback,
  }

  showBox()
}

QuestionQuillEditor.setDefaults = defaults => {
  QuestionQuillEditor.defaults = defaults
}

QuestionQuillEditor.open = (content, options) => {
  return QuestionQuillEditor(_.merge({
    content,
  }, options))
}

QuestionQuillEditor.close = () => {
  instance.visible = false
  currentBox = null
}

QuestionQuillEditor.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default QuestionQuillEditor
export { QuestionQuillEditor }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-quill-editor/src/main.js